import Swal from "sweetalert2";
import "../../src/pages/Employee/EmployeeDetails/style.css"

const bgMap = {
    success: { bg: "bg-success", text: "text-white" },
    error: { bg: "bg-danger", text: "text-white" },
    warning: { bg: "bg-warning", text: "text-dark" },
    info: { bg: "bg-info", text: "text-white" },
    question: { bg: "bg-secondary", text: "text-white" },
    primary: { bg: "bg-primary", text: "text-white" }
};

const getToastClass = (icon) => {
    switch (icon) {
        case "success":
            return "toast-success";
        case "error":
            return "toast-error";
        case "warning":
            return "toast-warning";
        case "info":
            return "toast-info";
        default:
            return "toast-default";
    }
};

export const showToast = ({
    icon = "success",
    title = "",
    text = "",
}) => {
    const selectedStyle = bgMap[icon] || bgMap.success;
    Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timerProgressBar: true,   // ✅ built-in progress bar
        timer: 4000,
        width: "320px",
        customClass: { popup: `custom-toast-card ${getToastClass(icon)}` },
        html: `
        <div class="toast-content">
             <div class="avatar">${icon.charAt(0).toUpperCase()}</div>
             <div class="text">
               <div class="title">${title}</div>
               <div class="subtitle">${text}</div>
             </div>
        </div>
    `,
        didOpen: (toast) => {
            const progressBar = toast.querySelector(".swal2-timer-progress-bar");

            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });
};

export const showConfirm = ({
    title = "Are you sure?",
    text = "",
    icon = "warning",
    confirmText = "Yes",
    cancelText = "No",
    confirmColor = "#3085d6",
    cancelColor = "#d33",
    onConfirm = () => { },
    onCancel = () => { }
}) => {
    Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        confirmButtonColor: confirmColor,
        cancelButtonColor: cancelColor
    }).then((result) => {
        if (result.isConfirmed) { onConfirm(); } else { onCancel(); }
    });
};